import '../sass/accordion.scss';

(() => {
    const detailsScript = document.querySelector('#ofg-schools-details-js');
    const $blocks = document.querySelectorAll('.block.accordion');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $items = $block.querySelectorAll('.accordion__item');

        const initAccordion = () => {
            if (!$items.length) return;

            const instances = [];

            $items.forEach($item => {
                instances.push({
                    el: $item,
                    instance: new Details($item),
                });
            });

            $block.addEventListener('detailsopen', (e) => {
                instances.forEach(({ el, instance }) => {
                    if (el !== e.target && el.open) {
                        instance.close();
                    }
                });
            });
        };

        if (typeof Details !== 'undefined') {
            initAccordion();
        } else if (detailsScript) {
            detailsScript.addEventListener('load', () => {
                initAccordion();
            });
        } else {
            window.addEventListener('load', () => {
                const detailsScript = document.querySelector('#ofg-schools-details-js');

                if (!detailsScript) return;

                initAccordion();
            });
        }
    });
})();
